import { Component, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import DEFAULT_TRANSLATIONS from '~assets/i18n/fr.json';
import { DEFAULT_LANG } from '~constants';
import { environment } from '~env';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body',
  templateUrl: './app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private translate: TranslateService) {}

  staging = environment.staging;

  ngOnInit(): void {
    this.initTranslation();
  }

  initTranslation() {
    this.translate.setTranslation(DEFAULT_LANG, DEFAULT_TRANSLATIONS);
    this.translate.setDefaultLang(DEFAULT_LANG);
  }
}
